module.exports = __webpack_public_path__ + "static/media/ChatArrow.b10bba75.png";